import Menu from "../component/Menu";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import MobileMenu from "../component/MobileMenu";
import { useAuthContext } from "@/context/Context";
import { useSidebar } from "../../../context/SidebarContext";

export default function Header() {
  const [activeMobileMenu, setActiveMobileMenu] = useState(false);
  const [loggedInUserId] = useState(null);
  const { loggedIn, loggedInUser, setLoggedIn, setLoggedInUser } = useAuthContext();
  const { isMobile, showMobileSidebar } = useSidebar();
  const [isOnProfile, setIsOnProfile] = useState(false);
  const [sidebarItems] = useState([
  
  ]);

  const navigate = useNavigate();

  // Note: Commented out Firebase auth listener since we're using backend authentication
  // If you need Firebase auth in the future, uncomment and modify this section
  /*
  auth.onAuthStateChanged((user) => {
    console.log(user);
    if (user && !loggedIn) {
      setLoggedIn(true);
      setLoggedInUser({
        mobileNumber: user.phoneNumber,
        uid: user.uid,
      });
    }
    if (!user && loggedIn) {
      setLoggedIn(false);
      setLoggedInUser(null);
    }
  });
  */
  function handleLogout() {
    // Clear localStorage and reset auth state for backend authentication
    localStorage.removeItem('user');
    setLoggedIn(false);
    setLoggedInUser(null);
    navigate("/");
  }

  return (
    <>
      <header className="header -type-1 ">
        <div className="header__container">
          <div className="row justify-between items-center">
            <div className="col-auto">
              <div className="header-left">
                <div className="header__logo ">
                  <Link to="/" className=" d-sm-block d-none">
                    <img src="/assets/img/general/logo.svg" alt="logo" />
                  </Link>
                  <Link to="/" className="d-block d-sm-none">
                    <img src="/assets/img/general/logo_mobile.svg" alt="logo" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div className="row justify-around items-center">
                <div className="col-auto">
                  {
                    <Menu
                      allClasses={"menu__nav text-white -is-active col-auto"}
                      headerPosition={"header__nav"}
                    />
                  }
                </div>

                <div className="col-auto">
                  <div className="header-right d-flex items-center">
                    <div className="header-right__icons text-white d-flex items-center">
                      {/* search toggle start */}
                      {/* <SearchToggle /> */}
                      {/* search toggle end */}

                      {/* cart toggle start */}
                      {/* {loggedIn && (
                        <CartToggle
                          parentClassess={"relative  xl:ml-20 mr-20"}
                          allClasses={"d-flex items-center text-white"}
                        />
                      )} */}
                      {/* cart toggle end */}
                     
                      {!loggedIn && isMobile && <div className="ml-20">
                        <button
                          onClick={() => showMobileSidebar()}
                          className="text-white items-center"
                          data-el-toggle=".js-mobile-menu-toggle"
                        >
                          <i className="text-11 icon icon-mobile-menu"></i>
                        </button>
                      </div>}
                    </div>

                    {!loggedInUserId ? (
                      <div className="header-right__buttons d-flex items-center  md:d-none">
                        {!loggedIn && (
                          <button
                            onClick={() =>
                              navigate("/login")
                            }
                            className="button -sm -white text-dark-1"
                          >
                            Log In
                          </button>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                    {loggedIn && (
                      <div
                        className="relative d-flex items-center ml-10"
                        onClick={() => {
                          if (isMobile) {
                            showMobileSidebar();
                          } else {
                            setIsOnProfile((pre) => !pre);
                          }
                        }}
                      >
                        {loggedInUser?.role === 'admin' && (
                          <span
                            className="d-flex items-center ml-3"
                            style={{
                              fontSize: '9px',
                              fontWeight: '600',
                              letterSpacing: '0.6px',
                              padding: '2px 5px',
                              borderRadius: '3px',
                              backgroundColor: 'rgba(251, 191, 36, 0.25)',
                              color: '#fbbf24',
                              border: '1px solid rgba(251, 191, 36, 0.5)'
                            }}
                            title="Administrator"
                          >
                            Admin
                          </span>
                        )}
                        <a
                          href="#"
                          data-el-toggle=".js-profile-toggle"
                          className="text-white text-30 "
                        >
                          <FontAwesomeIcon icon={faUser} />
                          {/* <img
                      className="size-50"
                      src="/assets/img/misc/user-profile.png"
                      alt="image"
                    /> */}
                        </a>

                        {!isMobile && (
                          <div
                            className={`toggle-element js-profile-toggle ${
                              isOnProfile ? "-is-el-visible" : ""
                            } -`}
                          >
                          <div className="toggle-bottom -profile bg-white shadow-4 border-light rounded-8 mt-10">
                            <div className="px-10 py-10">
                              <div className="sidebar -dashboard">
                                {sidebarItems.map((elm, i) => (
                                  <div
                                    key={i}
                                    className={`sidebar__item ${
                                      elm.id == 1
                                        ? "-is-active -dark-bg-dark-2"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      onClick={() => {
                                        navigate(elm.href);
                                      }}
                                      href={elm.href}
                                      className="d-flex items-center text-17 lh-1 fw-500 "
                                    >
                                      {/* <i className={elm.iconClass}></i> */}
                                      {elm.text}
                                    </button>
                                  </div>
                                ))}
                                {loggedIn && (
                                  <button
                                    onClick={() => {
                                      handleLogout();
                                      // setLoggedIn(false);
                                    }}
                                    className="button -sm text-17 lh-1 fw-500 text-dark-1 px-20"
                                  >
                                    Logout
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <MobileMenu
                  className="lg:d-none"
                  setActiveMobileMenu={setActiveMobileMenu}
                  activeMobileMenu={activeMobileMenu}
                />
              </div>
            </div>
            {/* <Menu allClasses={"menu__nav1 text-white -is-active"} /> */}
          </div>
        </div>
      </header>
    </>
  );
}
